import React from 'react'
import {donate} from './donate-data'
import './Donate.scss'

const Donate = ({romana}: { romana: boolean }) =>
    <div className="bg-white">
        <div className="offering" id="donate">
            <div>
                <p className="offering-subtitle">{romana ? donate['subtitle-ro'] : donate['subtitle-de']}</p>
                <h1 className="offering-header">{romana ? donate['header-ro'] : donate['header-de']}</h1>
                <p className="offering-text">{donate.text}</p>
            </div>
            <div>
                <img src={donate.image}/>
                <p className="offering-caption">{romana ? donate['caption-ro'] : donate['caption-de']}</p>
            </div>
        </div>
    </div>


export default Donate
